import '..//..//mixins.js'
//import AdvancedSearch from "../AdvancedSearch/AdvancedSearch.vue"
//import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
//import Autocomplete from '@trevoreyre/autocomplete-vue'




export default {
  name: 'responsiveheader',
  components: {
    //Autocomplete
  }
    ,
  props: [],
  data () {
    return {
      domain: "https://user.sigmafol.io/",
      startTime: new Date().toLocaleString().replace(',','')
    }
  },
  computed: {
    currentRoute() {
      return this.$router.currentRoute.name;
    }
  },
  methods: {
    async search(input) {
      let currentTime = new Date().toLocaleString().replace(',','')
      let msDifference =  currentTime - this.startTime;
      let minutes = Math.floor(msDifference/1000/60);
      if(minutes > 10){
        await this.verifyToken()
        this.startTime = currentTime
      }
      return new Promise((resolve, reject) => {
        if (input.length < 3) {
          return resolve([])
        }
        axios.post(this.domain + 'searchResults/?format=json', {"search": input},{
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                  }
          }).then(
              (response) => { 
                  var result = response.data;
                  console.log("results:", result)
                  if(result.length > 0){
                    resolve(result); 
                  }else{
                    let noResults = {
                      name: 'Keine Suchergebnisse',
                      isin: ''
                    }
                    resolve([noResults])
                  }
                  
              }, 
                  (error) => {
                  this.$router.go(0) 
                  reject(error); 
              } 
          ); 
      }); 
    },
    getResultValue(result) {
      return result.name
    },
    routeAssetDetail(isin){
      if(isin.length > 0){
        //let routeData = this.$router.resolve({name: "/assetDetail/" + isin, href: "https://www.sigmafol.io/"});
        //console.log(routeData)
        //window.open(routeData.href, '_blank');
        let routing = this.$router.currentRoute.name
        this.$router.push("/assetDetail/" + isin);

        if(routing.includes('assetDetail')){
          this.$router.go(0)
        }

      }
    },


  }
}
